import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { DesktopSearch } from 'components/Popups';
import { SearchItemsNums } from 'components/Popups/DesktopSearch/data';

import { useMemoSelector, useWindowSize } from 'hooks';
import { getSearchItemsNumState, setSearchItemsNum } from 'store';
import { SCREEN_BREAKPOINTS } from 'utils';

const SearchPanel = (): JSX.Element => {
  const dispatch = useDispatch();
  const { width: windowWidth } = useWindowSize();

  const searchItemsNum = useMemoSelector(getSearchItemsNumState);

  useEffect(() => {
    if (windowWidth <= SCREEN_BREAKPOINTS.desktopSmall && searchItemsNum !== SearchItemsNums.three) {
      dispatch(setSearchItemsNum(SearchItemsNums.three));
    }

    if (windowWidth > SCREEN_BREAKPOINTS.desktopSmall && searchItemsNum !== SearchItemsNums.seven) {
      dispatch(setSearchItemsNum(SearchItemsNums.seven));
    }
  }, [windowWidth, searchItemsNum, dispatch]);

  return <DesktopSearch />;
};

export default SearchPanel;
